import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowLeft, Check } from "lucide-react";

export default function ImpressionLivraison() {
  return (
    <div className="cs-cream py-14 min-h-[80vh]" data-testid="page-impression-livraison">
      <div className="max-w-[900px] mx-auto px-6 lg:px-12">
        <Link to="/" className="text-sm font-mono uppercase tracking-[0.16em] text-neutral-500 hover:text-black inline-flex items-center gap-2">
          <ArrowLeft size={14} /> Retour à l'accueil
        </Link>
        <div className="mt-6">
          <div className="cs-eyebrow text-[#0E7C90]">Impression &amp; livraison</div>
          <h1 className="cs-h1 mt-2 text-4xl lg:text-5xl">Vous souhaitez également recevoir vos supports imprimés&nbsp;?</h1>
          <p className="mt-6 text-neutral-700 text-[15px] leading-relaxed max-w-2xl">
            Charbonier Studio peut prendre en charge l'impression de votre création et sa livraison, une fois le fichier final validé.
            Vous conservez la maîtrise complète du projet&nbsp;: le tarif d'impression et de livraison vous est communiqué après vérification,
            et aucune impression n'est lancée sans votre accord.
          </p>
        </div>

        <div className="mt-10 cs-card p-6">
          <div className="cs-eyebrow text-neutral-500">Comment ça fonctionne</div>
          <ol className="mt-3 space-y-3 text-[15px]">
            <li className="flex gap-3"><span className="font-mono text-[12px] text-[#0E7C90] pt-1">01</span> Vous choisissez « Je souhaite recevoir les supports imprimés » à la fin du parcours « Créer mon support ».</li>
            <li className="flex gap-3"><span className="font-mono text-[12px] text-[#0E7C90] pt-1">02</span> Vous indiquez la quantité souhaitée et vos éventuelles exigences (papier, finition, adresse…).</li>
            <li className="flex gap-3"><span className="font-mono text-[12px] text-[#0E7C90] pt-1">03</span> Après validation de votre fichier final, Charbonier Studio vous transmet un devis d'impression et de livraison.</li>
            <li className="flex gap-3"><span className="font-mono text-[12px] text-[#0E7C90] pt-1">04</span> L'impression n'est lancée qu'après votre accord explicite.</li>
          </ol>
        </div>

        <div className="mt-6 cs-card p-6">
          <div className="cs-eyebrow text-neutral-500">Bon à savoir</div>
          <ul className="mt-3 space-y-2 text-[14px]">
            {[
              "Le tarif dépend de la quantité, du support choisi et des finitions.",
              "La livraison est assurée à l'adresse que vous indiquez lors du devis.",
              "Vous pouvez toujours choisir de recevoir uniquement les fichiers — l'option d'impression reste facultative.",
            ].map((x, i) => (
              <li key={i} className="flex items-start gap-2"><Check size={16} className="text-[#0E7C90] mt-0.5" /> {x}</li>
            ))}
          </ul>
        </div>

        <div className="mt-8 flex gap-3 flex-wrap">
          <Link to="/creer-mon-support" className="cs-btn-primary inline-flex items-center gap-2" data-testid="ip-cta-create">
            Créer mon support <ArrowUpRight size={16} />
          </Link>
          <Link to="/demande-devis" className="cs-btn-ghost !text-black !border-black inline-flex items-center gap-2">
            Poser une question <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
}
